import { css } from "@obby/components";

export const styles = {
  joinHeader: css({
    zIndex: "$menuHeader",
    position: "fixed",
    top: "0",
    width: "100%",
    transition: "all 400ms ease-in-out",
    borderBottom: "1px solid transparent"
  }),
  filled: css({
    backgroundColor: "white",
    "@lg": {
      borderBottomColor: "#f4f4f5"
    }
  })
};
